import { cn } from "@/lib/utils";

export const getCardBaseClasses = (hasActiveBadge?: boolean) => cn(
  "relative bg-card border border-border rounded-lg pt-4 pb-3 px-3 sm:px-4 sm:pt-6 sm:pb-4 transition-all hover:bg-accent cursor-pointer shadow-sm hover:shadow-md overflow-visible"
);

export const getCardStatusBarClasses = (statusColor: string) => {
  const colorMatch = statusColor.match(/bg-(\w+-\d+)/);
  const color = colorMatch ? colorMatch[1] : 'gray-500';
  return cn(`border-l-4 border-l-${color}`);
};

export const getCardHeaderClasses = () => cn(
  "flex items-start justify-between mb-1 sm:mb-2"
);

export const getCardTitleClasses = () => cn(
  "text-sm sm:text-base font-medium text-foreground flex-1 line-clamp-2 leading-tight"
);

export const getCardDateClasses = () => cn(
  "text-xs sm:text-sm text-muted-foreground mb-1 sm:mb-2 leading-tight"
);

export const getCardMetadataClasses = () => cn(
  "flex items-center gap-3 sm:gap-4 text-xs sm:text-sm text-muted-foreground"
);

export const getCardActionButtonClasses = () => cn(
  "flex-shrink-0 p-1 text-muted-foreground hover:text-foreground hover:bg-accent rounded transition-colors"
);

export const getCardActiveClasses = () => cn(
  "ring-2 ring-primary bg-primary/5"
);

export const getCardDisabledClasses = () => cn(
  "opacity-50 cursor-not-allowed"
);

export const getCardFooterClasses = () => cn(
  "mt-1 space-y-1"
);

export const getCardFooterRowClasses = () => cn(
  "flex items-center justify-between"
);